import { createFileRoute } from '@tanstack/react-router'
import { ensureNamespace } from '@/lib/i18n/runtime'
import { MarketplacePage, type MarketplaceSearch } from '@/features/plugins/marketplace/MarketplacePage'

export const Route = createFileRoute('/_auth/integrations')({
  beforeLoad: async () => {
    await Promise.all([ensureNamespace('shell'), ensureNamespace('marketplace')]).catch(() => {
      // The namespace boundary exposes a translated error and retry.
    })
  },
  validateSearch: (search: Record<string, unknown>): MarketplaceSearch => ({
    package: typeof search.package === 'string' ? search.package : undefined,
  }),
  component: IntegrationsRoute,
})

// eslint-disable-next-line react-refresh/only-export-components
function IntegrationsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return <MarketplacePage search={search} onSearchChange={next => { void navigate({ search: next }) }} />
}
